import React from "react";
import Logo from "./Files/Logo.png";
import "./Components.css";

const Header_Navbar = () => {

    const trips = [
        { name: "Korsika", link: "/korsika" },
        { name: "Schweden 2025/26", link: "/schweden2026" },
        { name: "Thailand 2025", link: "/thailand2025" },
        { name: "Schottland", link: "/schottland" },
        { name: "Schweden", link: "/schweden" },
        { name: "Norwegen", link: "/norwegen" },
        { name: "Zandvoort", link: "/zandvoort" },
        { name: "Sri Lanka", link: "/srilanka" },
        { name: "Thailand", link: "/thailand" },
        { name: "Split", link: "/split" },
        { name: "Mauritius", link: "/mauritius" },
        { name: "Belize", link: "/belize" }
    ];

    return (
        <header className="modern-navbar">
            <div className="navbar-inner">

                <a className="navbar-logo" href="/">
                    <img src={Logo} alt="Logo" />
                </a>

                <nav className="navbar-links">

                    <a href="/">Home</a>

                    <a href="/aboutme">About</a>

                    <a href="/blog">Reiseverlauf</a>

                    <div className="nav-dropdown">

                        <button className="dropdown-trigger">
                            Reisen
                        </button>

                        <div className="dropdown-content">
                            {trips.map((trip, index) => (
                                <a key={index} href={trip.link}>
                                    {trip.name}
                                </a>
                            ))}
                        </div>

                    </div>

                </nav>

            </div>
        </header>
    );
};

export default Header_Navbar;